import React, { useLayoutEffect } from 'react';
import { Tabs, TabList } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { LanguageNew } from '../../../../types/Common';
import LanguageTab from './LanguageTab';

interface TabType {
  label: string;
  value: LanguageNew;
}

interface Props {
  value: LanguageNew;
  onChange: (lang: LanguageNew) => void;
  completedTabs: LanguageNew[];
  customTabs?: TabType[];
  isFitted?: boolean;
}

const LanguageTabs: React.FC<Props> = ({
  value,
  onChange,
  completedTabs,
  customTabs,
  isFitted = true,
}) => {
  const { t } = useTranslation();
  const defaultTabs: TabType[] = [
    {
      label: t('English'),
      value: 'en' as LanguageNew,
    },
    {
      label: t('Dutch'),
      value: 'nl' as LanguageNew,
    },
    {
      label: t('French'),
      value: 'fr' as LanguageNew,
    },
    {
      label: t('GERMAN'),
      value: 'de' as LanguageNew,
    },
  ];
  const tabs = customTabs || defaultTabs;

  const handleChange = (index: number) => {
    onChange(tabs[index].value);
  };

  useLayoutEffect(() => {
    if (!tabs.some((tab) => tab.value === value)) {
      handleChange(0);
    }
  }, []);

  return (
    <Tabs
      index={tabs.findIndex((tab) => tab.value === value)}
      onChange={handleChange}
      isFitted={isFitted}
    >
      <TabList>
        {tabs.map(({ label, value: lang }) => {
          return (
            <LanguageTab
              isComplete={completedTabs.includes(lang)}
              key={`lang_tab_${lang}`}
            >
              {label}
            </LanguageTab>
          );
        })}
      </TabList>
    </Tabs>
  );
};

export default LanguageTabs;
